import { render, staticRenderFns } from "./tollFreeEditForm.vue?vue&type=template&id=47e8d02b&scoped=true&"
import script from "./tollFreeEditForm.vue?vue&type=script&lang=js&"
export * from "./tollFreeEditForm.vue?vue&type=script&lang=js&"
import style0 from "./tollFreeEditForm.vue?vue&type=style&index=0&id=47e8d02b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8d02b",
  null
  
)

export default component.exports